/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { CountryCode } from '@app/common/components/dialog-update-credit-card/countries';
import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { BillingCard, BillingCardId } from '@shared/types/billing';
import { StripeCardNumberElement, StripeError } from '@stripe/stripe-js';

export const getBillingMethods = createAction('[Billing] Get billing methods');
export const getBillingMethodsErr = createAction('[Billing] Get billing methods err', props<GmcError>());
export const billingMethods = createAction('[Billing] Billing methods', props<{ data: BillingCard[] }>());

export const removeCardIntent = createAction('[Billing] Remove card intent', props<{ cardId: BillingCardId }>());
export const removeCard = createAction('[Billing] Remove card', props<{ cardId: BillingCardId }>());
export const removeCardOK = createAction(
  '[Billing] Remove card OK',
  props<{ cardId: BillingCardId; notification?: string }>(),
);
export const removeCardErr = createAction('[Billing] Remove card ERR', props<GmcError & { cardId: BillingCardId }>());

export const updateBillingMethod = createAction(
  '[Billing] Update billing method',
  props<{
    // Can't pass the reference to DOM node because calling `freeze` over it causes runtime errors
    getStripeCardElement: () => StripeCardNumberElement;
    country: CountryCode;
    city: string;
    postalCode: string;
    state: string;
    streetAddress: string;
    company: string;
    cardholderName: string;
  }>(),
);
export const updateBillingMethodOK = createAction(
  '[Billing] Update billing method OK',
  props<{ notification?: string }>(),
);
export const updateBillingMethodErr = createAction(
  '[Billing] Update billing method Err',
  props<GmcError & { details?: Partial<StripeError> }>(),
);
